import linkifyHtml from 'linkify-html'

export enum LinkAnimationType {
  SlideRight,
  LaunchUp,
}

export const convertToLink = (text: string) => {
  const options = {
    defaultProtocol: 'http',
    attributes: {
      style: 'color: #00f; text-decoration: underline;',
    },
    formatHref: (href: string) => {
      const url = new URL(href, 'http://straya.com')

      // 各リンクごとにGoogle Mapsかどうかを判定
      if (isGoogleMapLink(href)) {
        url.searchParams.append('launch_app', 'true')
      } else {
        url.searchParams.append('slide', 'right')
      }

      return url.href.replace('http://straya.com', '')
    },
  }
  return linkifyHtml(text, options)
}

export const isGoogleMapLink = (url: string): boolean => {
  return (
    (url.includes('google') && url.includes('maps')) ||
    url.includes('maps.app.goo.gl')
  )
}
